// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5f-2";
export var blackBorderOnHover = "_5f-7";
export var cell = "_5f-6";
export var cellContainer = "_5f-3";
export var checked = "_5f-8";
export var disabled = "_5f-5";
export var featuredIconCellContainer = "_5f-9";
export var featuredIconTextContainer = "_5f-b";
export var featuredIconWrapper = "_5f-a";
export var noBorder = "_5f-c";
export var orangeSelectedRow = "_eg-3";
export var overflowableText = "_5f-0";
export var overflowableTextContainer = "_5f-1";
export var row = "_5g-0";
export var rowCheckboxCell = "_5f-4";
export var selectableTable = "_eg-2";